import { PRIMARY_COLOR } from 'src/config/api';

const palette = {
    primary: PRIMARY_COLOR,
    secondary: '#FFFFFF',
    red: `#e34b1b`,
    sky: `#598bd4`,
    blue: `#039be5`,
    dashboard: `#0075e3`,
    letter: '#222',
    grey: '#ccc',
    white: ['#FFFFFF', '#f8f8f8', '#f0f0f0', '#cccccc', '#9e9e9e', '#666666', '#222222', '#888'],
    width: '720px',
    h1: '2.4rem', // 상세페이지의 상품 이름처럼 제일 큰 강조 표시에 사용되는 크기
    h2: '2rem',
    largeFont: '1.8rem', // 소제목 ex) 상세페이지의 배송 정보 등과 같은 크기
    mediumFont: '1.6rem', // 평균 크기, 일반 적인 텍스트들
    smallFont: '1.4rem', // 작은 크기, 설명 등

    borderLine: '1px solid #ccc',
    standardPadding: '16px',
};

export default palette;
